import { Select } from "@fidelix/fx-miranda";
import { styled } from "styled-components";
import { useNavigate } from "react-router-dom";
import { useCompaniesQuery } from "~company/company.queries";
import { useRequiredParams } from "~utils/url";
import { useUserContext } from "../user/user-context";
import { setCompanyToLocalStorage } from "../helper";

export function CompanySelect() {
  const { companyId } = useRequiredParams({ companyId: "string" });
  const { data: companies = [] } = useCompaniesQuery();
  const { resetContext } = useUserContext();
  const navigate = useNavigate();

  function handleSelect(value: string | number | null) {
    if (!value || String(value) === companyId) {
      return;
    }
    resetContext();
    setCompanyToLocalStorage(value);
    navigate(`/company/${value}`);
  }

  return (
    <NavSelect
      key={companyId}
      isFilterable={true}
      data-test-id="company-select"
      aria-label="Companies"
      placeholder={
        companies.find((c) => c.id === Number(companyId))?.name || ""
      }
      selected={companyId}
      onSelect={handleSelect}
      maxHeight="350px"
    >
      {companies.map((company) => (
        <Select.Option
          key={company.id}
          value={String(company.id)}
          textValue={company.name}
        >
          <SelectText>{company.name}</SelectText>
        </Select.Option>
      ))}
    </NavSelect>
  );
}

const SelectText = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const NavSelect = styled(Select)`
  flex-shrink: 1;
  min-width: 100px;
  width: 300px;
  button {
    background-color: ${(p) => p.theme.colors.white};
  }
`;
